import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appTextareaPlaceholder]',
  host: {
    '[attr.data-text]': 'attribute',
  },
})
export class TextareaPlaceholderDirective {
  @Input({ required: true }) placeholder: string;

  public attribute = '';

  public ngOnInit(): void {
    this.attribute = this.placeholder;
  }

  @HostListener('input', ['$event.target'])
  public onInput(element: HTMLTextAreaElement): void {
    if (element?.innerText?.trim()) {
      this.attribute = '';
    } else {
      this.attribute = this.placeholder;
    }
  }
}
